import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = `/aiconversation/<id>/chatMessage`;

interface QueryParams {
	id: string;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}

export function getConversationChatMessageQueryKey(queryParams: QueryParams): any[] {
	// Extract only the plain data needed from impersonationContext to avoid circular references
	// when the MobX observable is serialized
	const impersonationKey = queryParams.impersonationContext
		? {
				accountId: queryParams.impersonationContext.account?.id,
				userId: queryParams.impersonationContext.user?.id,
			}
		: undefined;
	return [BASE_QUERY_KEY, queryParams.id, impersonationKey];
}

export function useAIConversationChatMessageQuery(queryParams: {
	id: string;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
	initialData?: Api.AIChatMessage[];
	staleTime?: number;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: getConversationChatMessageQueryKey(queryParams),
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.AIChatMessage[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `aiconversation/${queryParams.id}/chatMessage`,
					impersonationContext: queryParams.impersonationContext,
				}),
				'GET'
			),
		enabled: queryParams.enabled,
		initialData: queryParams.initialData,
		staleTime: queryParams.staleTime,
	});
}
